import type { IconProps } from './IconProps';

export const NotificationIndicatorIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 8}
    height={props.height ?? 8}
    {...props}
  >
    <circle cx="4" cy="4" r="3" fill="var(--token-color-purple-900)" />
  </svg>
);
